import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Confirm from "../Confirm";
import { useLocation, useNavigate, Link } from "react-router-dom";
import trasportApi from "../../api/trasportApi";
import Main from "../layout/Main";
import Helmet from "react-helmet";
import { BsChevronRight } from "react-icons/bs";
import PubSub from "pubsub-js";

const ContactView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [client, setClientclient] = useState(
    location.state ? location.state.id : {}
  );
  const [modalShow, setModalShow] = useState(false);

  //Commented Due to some fields on 24-Dec-2024
  useEffect(() => {
    fetchclient();
  }, []);

  const fetchclient = async () => {
    // if (!client.id && location.hasOwnProperty("pathname")) {
    //   client.id = location.pathname.split("/")[2];
    //   //console.log("pathnam===" + contact.id);
    // }
    let challanRecords = await trasportApi.fetchDriverPaymentById(
      location.state ? location.state.id : client.id
    );

    if (challanRecords) {
      console.log("challanRec", challanRecords);
      setClientclient(challanRecords);
    }
  };

  const isdelete = async () => {
    let result = await trasportApi.deleteDriverPayment(client.id);
    if (result.success) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Record Saved",
        message: "Record deleted successfully",
      });
      navigate(`/driverpayments`);
    }
  };

  const editclient = () => {
    navigate(`/driverpayments/${client.id}/e`, { state: client });
  };
  console.log("client", client);
  return (
    <Main>
      <>
        <Helmet>
          <title>{`${client.challan_name}`}</title>
        </Helmet>
      </>
      <div>
        {client && (
          <Container>
            {modalShow && (
              <Confirm
                show={modalShow}
                onHide={() => setModalShow(false)}
                isdelete={isdelete}
                title="Confirm delete?"
                message="You are going to delete the record. Are you sure?"
                table="client"
              />
            )}

            <Col lg={2} className="mx-2">
              <Link to="/home" style={{ "text-decoration": "none" }}>
                Home
              </Link>{" "}
              {/* <i className="fa-solid fa-chevron-right"></i> */}
              <BsChevronRight />
              <Link to="/driverpayments" style={{ "text-decoration": "none" }}>
                Driver Payments
              </Link>
            </Col>
            <Row className="view-form">
              <Col></Col>
              <Col lg={8}>
                <Row className="view-form-header align-items-center">
                  <Col lg={4}>
                    <h5>
                      Vehicle Number: {client.vehicle_number || ""} (Driver:{" "}
                      {client.driver_name || ""})
                    </h5>
                  </Col>
                  <Col lg={8} className="d-flex justify-content-end">
                    <Col style={{ marginLeft: "180px" }}>
                      <p>{client.fname || ""}</p>
                    </Col>
                    <Button
                      className="btn-sm mx-2"
                      onClick={() => editclient(true)}
                    >
                      <i className="fa-regular fa-pen-to-square"></i>
                    </Button>
                    <Button
                      className="btn-sm"
                      variant="danger"
                      onClick={() => setModalShow(true)}
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <label>Vehicle Number</label>
                    <span>{client.vehicle_number || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Driver Name</label>
                    <span>{client.driver_name || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Payment Status</label>
                    <span>{client.payment_status || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Paid Amount</label>
                    <span>{client.payamount || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Pay Balance</label>
                    <span>{client.paybalance || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Payment Date</label>
                    <span>
                      {client.pay_date
                        ? new Date(client.pay_date).toLocaleDateString()
                        : ""}
                    </span>
                  </Col>
                  <Col lg={6}>
                    <label>Debit Amount</label>
                    <span>{client.debit_amount || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Remark</label>
                    <span>{client.remark || ""}</span>
                  </Col>
                  {/* Section for User Information */}
                  <Col lg={12}>
                    <Col className="section-header my-3">
                      <span style={{ color: "blue", paddingLeft: "10px" }}>
                        User Information
                      </span>
                    </Col>
                  </Col>
                  <Col lg={6}>
                    <label>Created By</label>
                    <span>{client.createdbyname || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Last Modified By</label>
                    <span>{client.lastmodifiedbyname || ""}</span>
                  </Col>
                </Row>
              </Col>
              <Col></Col>
            </Row>
          </Container>
        )}
      </div>
    </Main>
  );
};
export default ContactView;
